import { mapState, mapGetters, mapActions } from 'vuex'

export const friendListComputed = {
  ...mapState('friendList', {
    loading: (state) => state.loading,
  }),
  ...mapGetters('friendList', ['getFriendList']),
}

export const friendListMethods = mapActions('friendList', [
  'fetchingFriendList',
  'resetFriendList',
])
